import React from "react";

function Features(){
    return(
        <div className="features text-center "  >
            <p className="text-center">Estimated delivery time: 2-7 days</p>
            <p className="text-center">Free shipping on all orders.</p>
            <p className="text-center">7 Days Returns Available</p>
        </div>
    )
}

export default Features